import { Reveal } from "./Reveal";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const faqs = [
  {
    q: "How much meat will I actually get?",
    a: "There's no guaranteed poundage — every steer is different. As a guide, most quarters run 200–225 lbs on the hanging weight (about $1,450–$1,630), and halves run $2,900 or more. Your final price is based on the actual hanging weight of your animal.",
  },
  {
    q: "How much freezer space do I need?",
    a: "As a rough guide, plan on about 1 cubic foot per 25–30 lbs of beef. A quarter typically fills 4–5 cu ft (most upright freezers), while halves and wholes call for a dedicated chest freezer.",
  },
  {
    q: "What cuts will I get?",
    a: "All cuts are included — sirloins, ribeyes, T-bones, chuck roast, shoulder roast, rump roast, cubed steak, plenty of ground beef, short ribs, brisket, flank steak, soup bones, and fat for making tallow. Organs on request. We never sell individual cuts.",
  },
  {
    q: "Why grain finished instead of 100% grass fed?",
    a: "Our Angus are grass fed with a natural grain finish — grass builds honest flavor, and the grain finish builds the marbling and tenderness most people want from a steak.",
  },
  {
    q: "Can I split a quarter?",
    a: "No — a quarter can't be divided before harvest. But once the meat is in your hands, you're welcome to split it up with friends or family however you like.",
  },
  {
    q: "When will my beef be ready?",
    a: "Beef is usually available all year long. Your share is typically ready 4–6 weeks after you reserve.",
  },
  {
    q: "Where do the cattle come from?",
    a: "Every animal is one of ours — Angus and Angus cross, Florida raised and finished on a family farm.",
  },
  {
    q: "Do you accept credit cards?",
    a: "We'll reach out with payment options after you reserve — no credit cards needed. Deposits hold your animal and all sales are final.",
  },
  {
    q: "Is the deposit refundable?",
    a: "No refunds — all sales are final. A deposit is required to reserve your animal and is non-refundable, since your steer is set aside and finished just for you. The balance is due on delivery, calculated on the actual hanging weight.",
  },
  {
    q: "How do I get my beef?",
    a: "All meat is cut, vacuum-sealed, labeled, and frozen by North Florida Custom Meats, then transported in our heavy-duty coolers. We meet you at a central location — we serve Jacksonville, FL and the surrounding counties. One thing to plan for: please bring your own large coolers or insulated bags to the meetup. Our coolers stay with us, and a share can be several hundred pounds of beef.",
  },
];

export const Faq = () => (
  <section id="faq" className="py-24 lg:py-32" data-testid="faq-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12">
      <Reveal className="lg:col-span-4">
        <p className="text-xs tracking-[0.25em] uppercase font-bold text-clay mb-4">Questions</p>
        <h2 className="font-display text-3xl sm:text-4xl tracking-tight font-medium leading-tight">
          Frequently asked questions
        </h2>
      </Reveal>
      <Reveal delay={0.12} className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {faqs.map((f, i) => (
            <AccordionItem key={i} value={`faq-${i}`} className="border-b border-linen">
              <AccordionTrigger
                data-testid={`faq-question-${i}`}
                className="font-display text-xl sm:text-2xl tracking-tight font-medium text-left py-6 hover:text-clay transition-colors duration-200 hover:no-underline"
              >
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-moss text-lg leading-relaxed pb-6 max-w-2xl" data-testid={`faq-answer-${i}`}>
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </Reveal>
    </div>
  </section>
);
